import { render, staticRenderFns } from "./Lista_UtilizxBeneficiario.vue?vue&type=template&id=d7828934&scoped=true&"
import script from "./Lista_UtilizxBeneficiario.vue?vue&type=script&lang=js&"
export * from "./Lista_UtilizxBeneficiario.vue?vue&type=script&lang=js&"
import style0 from "./Lista_UtilizxBeneficiario.vue?vue&type=style&index=0&id=d7828934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7828934",
  null
  
)

export default component.exports